import ACLogo from './icsa-ball'
import homeSVG from './homeSVG.svg'
import SpeakerSVG from './speaker'
import ProgrammeSVG from './programme'
import ExhibitorsSVG from './exhibitors'
import LocationSVG from './location'
import InfoSVG from './info'
import ContactSVG from './contact'
import MenuSVG from './menu'
import SearchSVG from './search'
import LinkSVG from './link'
import ICSALogoSVG from './icsa-cgi-logo'
import ICSAPortraitLogoSVG from './icsa-cgi-portrait'
import ICSACrestSVG from './icsa-crest'
import FacebookSVG from './facebook'
import TwitterSVG from './twitter'
import LinkedInSVG from './linkedin'
import FlickrSVG from './flickr'
import VenueMapSVG from './maps/VenueMap'
import ExhibitionMapSVG from './maps/ExhibitionMap'

export {
  ACLogo,
  homeSVG,
  SpeakerSVG,
  ProgrammeSVG,
  ExhibitorsSVG,
  LocationSVG,
  InfoSVG,
  ContactSVG,
  MenuSVG,
  SearchSVG,
  LinkSVG,
  ICSALogoSVG,
  ICSAPortraitLogoSVG,
  ICSACrestSVG,
  FacebookSVG,
  TwitterSVG,
  LinkedInSVG,
  FlickrSVG,
  VenueMapSVG,
  ExhibitionMapSVG
}